const setupProps = {
  data: {
    type: 'Array',
    children: {
      type: 'Object',
      props: {
        type: { type: 'String' },
        name: { type: 'String' },
        value: { type: 'String', default: '' },
        display: { type: 'String', default: '' },
        label: { type: 'String', optional: true },
        placeholder: { type: 'String', optional: true },
        iql_column: { type: 'String', optional: true },
        iql_function: { type: 'String', optional: true },
        iql_operator: { type: 'Array', optional: true },
        iql_multiselect_operator: { type: 'String', optional: true },
        options: { type: 'Array', optional: true },
        options_unlimited: { type: 'Number', optional: true },
        default: { type: 'Number', optional: true },
        active: { type: 'Boolean', default: false },
        toggle: { type: 'Boolean', default: false },
        showOptions: { type: 'Boolean', default: false },
      },
    },
  },
};

// Exported
export default { ...setupProps };
